'use client';

import React from 'react';
import { motion, AnimatePresence as AnimatePresenceComponent } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { formatAmount } from '../../../utils/funcs';
import { ECart, EQuerykeys } from '../../../models';
import { useCartAnalytics } from '../../../hooks/useCartAnalytics';
import { getSessionInfo } from '../../../utils/getSessionInfo';
import RightArrowIconSvg from '../../svgs/RightArrowIconSvg';
import { useGetCart } from '../../../integrations/react_query/queries';
import styles from './index.module.scss';

const AnimatePresence = AnimatePresenceComponent as React.FC<any>;

const CartBreakdownMobile: React.FC = () => {
	const navigate = useNavigate();
	const { data: cartItems } = useGetCart([EQuerykeys.cart, ECart.active]);
	const { cartLength, totalSavings, vatAmount, payableAmount, cartSumWithoutDiscount } = useCartAnalytics(
		cartItems?.products
	);
	const { companyInfo } = getSessionInfo();
	const VAT = companyInfo?.tax ?? 0;

	if (cartLength <= 0) return null;

	return (
		<AnimatePresence>
			<motion.div
				key="cart-breakdown"
				initial={{ y: '100%', opacity: 0 }}
				animate={{ y: 0, opacity: 1 }}
				exit={{ y: '100%', opacity: 0 }}
				transition={{ duration: 0.3, ease: 'easeOut' }}
				className="flex md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-2xl z-[400]"
			>
				<div className="w-full px-2 py-3 space-y-2">
					<div className="flex justify-between">
						<div>
							<span className={`block text-[#2D3748] ${styles.amountLabel}`}>Subtotal</span>
							<span className={`font-semibold text-[#171923] ${styles.amountValue}`}>
								{formatAmount(cartSumWithoutDiscount)}
							</span>
						</div>
						<div className="text-right">
							<span className={`block text-[#2D3748] ${styles.amountLabel}`}>Total Savings</span>
							<span className={`font-semibold text-[#171923] ${styles.amountValue}`}>{formatAmount(totalSavings)}</span>
						</div>
					</div>

					{VAT > 0 && (
						<div className="flex justify-between">
							<span className={`${styles.amountLabel} text-[#2D3748]`}>VAT ({VAT}%)</span>
							<span className={`font-semibold text-[#171923] ${styles.amountValue}`}>{formatAmount(vatAmount)}</span>
						</div>
					)}

					<div className="flex items-center justify-between gap-3 pt-2 border-t border-gray-200">
						<div>
							<span className={`block text-xs text-[#2D3748] ${styles.amountLabel}`}>
								Total{' '}
								<span className="text-xs text-[#2D3748] ml-1">
									({cartLength} item{cartLength !== 1 ? 's' : ''})
								</span>
							</span>
							<div className={`text-sm font-bold text-[#171923] ${styles.amountValue}`}>
								{formatAmount(payableAmount)}
							</div>
						</div>

						<button
							onClick={(e) => {
								e.preventDefault();
								navigate('/payment');
							}}
							className={`flex items-center flex-shrink-0 px-6 py-2 bg-[#51D4A7] text-white opacity-90 font-semibold rounded-lg transition-colors whitespace-nowrap gap-2 ${styles.payButton}`}
						>
							Pay
							<RightArrowIconSvg />
						</button>
					</div>
				</div>
			</motion.div>

			<div className="flex md:hidden h-32" />
		</AnimatePresence>
	);
};

export default CartBreakdownMobile;
